import React from 'react';
import styles from './Agent.css';
import classNames from 'classnames';

interface IAgentComponentProps {
  promoted: boolean;
  avatar: React.ReactNode;
  title: React.ReactNode;
  proofs: React.ReactNode;
  badge: React.ReactNode;
  phoneButton: React.ReactNode;
  showMoreOffersButton: React.ReactNode;
  builderLabels?: React.ReactNode;
  contactStatus?: React.ReactNode;
}

export function Agent({
  promoted,
  avatar,
  badge,
  title,
  builderLabels,
  contactStatus,
  proofs,
  showMoreOffersButton,
  phoneButton,
}: IAgentComponentProps) {
  return (
    <div className={classNames(styles['cont'], promoted && styles['cont-promoted'])}>
      <div className={styles['avatar-cont']}>
        <div className={styles['avatar']}>{avatar}</div>
        <div className={styles['title']}>
          {badge && <div className={styles['badge']}>{badge}</div>}
          <div className={'title-text'}>{title}</div>
        </div>
      </div>
      {proofs}
      {builderLabels}
      <div className={styles['phone-button']}>{phoneButton}</div>
      {showMoreOffersButton}
      {contactStatus && <div className={styles['contact-status']}>{contactStatus}</div>}
    </div>
  );
}
